import Progress from 'redux-progress';

import type { OrdersAction, OrdersData } from '../models/orders';
import {
  QUOTES_POST,
  SEARCH_FOR_CONTACT_POST,
  PO_NUMBER_UPDATE_MODAL_CLOSE,
  PO_NUMBER_UPDATE_MODAL_OPEN,
  CART_COPY_FOR_EDITING,
  VERIFICATION_HASH,
  SINGLE_ORDER,
  CART_CLONE_QUOTE,
  CART_CLEAR_CLONE_QUOTE,
  EDITED_CART_ORDER,
} from 'modules/mac/duck/actions/orders';

export const initialState: OrdersData = {
  quotes: Progress.none,
  invoices: Progress.none,
  isPONumberUpdateModalOpened: false,
  orderDetailsForPONumberUpdateModal: null,
  copiedCartForEditing: Progress.none,
  verificationHash: Progress.none,
  singleOrder: Progress.none,
  clonedOrder: Progress.none,
  editedCartOrder: Progress.none,
};

export default (state: OrdersData = initialState, action: OrdersAction): OrdersData => {
  switch (action.type) {
    case QUOTES_POST:
      return {
        ...state,
        quotes: action.progress,
      };
    case SEARCH_FOR_CONTACT_POST:
      return {
        ...state,
        invoices: action.progress,
      };
    case CART_COPY_FOR_EDITING:
      return {
        ...state,
        copiedCartForEditing: action.progress,
      };
    case PO_NUMBER_UPDATE_MODAL_OPEN:
      return {
        ...state,
        isPONumberUpdateModalOpened: true,
        orderDetailsForPONumberUpdateModal: action.orderDetails,
      };
    case PO_NUMBER_UPDATE_MODAL_CLOSE:
      return {
        ...state,
        isPONumberUpdateModalOpened: false,
        orderDetailsForPONumberUpdateModal: null,
      };
    case VERIFICATION_HASH:
      return {
        ...state,
        verificationHash: { ...state.verificationHash, [action.id]: action.progress },
      };
    case SINGLE_ORDER:
      return {
        ...state,
        singleOrder: { ...state.singleOrder, [action.id]: action.progress },
      };
    case EDITED_CART_ORDER:
      return {
        ...state,
        editedCartOrder: action.progress,
      };
    case CART_CLONE_QUOTE:
      return {
        ...state,
        clonedOrder: action.progress,
      };
    case CART_CLEAR_CLONE_QUOTE:
      return {
        ...state,
        clonedOrder: Progress.none,
      };
    default:
      return state;
  }
};
